import '../index.css'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import set from 'lodash/set'
import * as React from 'react'
import { connect } from 'react-redux'
import validation from 'react-validation-mixin'
import strategy from 'react-validatorjs-strategy'
import scrollIntoView from 'scroll-into-view-if-needed'
import type { ButtonProps } from 'types/content-editor'
import type { Playlist } from 'types/playlist'
import type { ValidationProps } from 'types/validation'
import { getPlaylists } from '@disco/state-management/selectors/playlists'
import { fixLink, LINK_VALIDATOR, validateLink } from '@disco/utils/links'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import ButtonPropsView from './view'

const mapStateToProps = state => {
  return {
    playlists: getPlaylists(state),
  }
}

class ButtonSettings extends React.Component<
  {
    value: ButtonProps
    onSubmit: (form: Record<string, any>) => unknown
    onCancel: () => unknown
    playlists: Record<number, Playlist>
  } & ValidationProps,
  {
    value: Record<string, any>
  }
> {
  _paneRef: {
    current: null | HTMLDivElement
  } = React.createRef()
  _scrollingRef: HTMLDivElement | null | undefined
  state = {
    value: this.props.value,
  }
  validatorTypes = strategy.createSchema(
    {
      link: 'LINK_VALIDATOR',
    },
    {
      [LINK_VALIDATOR]: 'The url format is invalid.',
    },
    validator => {
      validator.constructor.register('LINK_VALIDATOR', validateLink)
    },
  )
  getValidatorData = () => {
    return {
      link: this.state.value.link,
    }
  }
  _onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = cloneDeep(this.state.value)
    set(value, e.target.name, e.target.value)

    if (e.target.name === 'link') {
      set(value, 'playlist_id', null)
      set(value, 'link', fixLink(e.target.value))
    }

    this.setState({
      value,
    })
  }
  _onColorChange = (prop: string, color: string) => {
    let value = cloneDeep(this.state.value)
    set(value, prop, color)
    this.setState({
      value,
    })
  }
  _onPlaylistSelect = (playlist_id: number) => {
    const value = {
      ...this.state.value,
      playlist_id,
      link: get(this.props.playlists[playlist_id], 'view_playlist_url', ''),
    }
    this.setState({
      value,
    })
  }
  _handleSubmit = () =>
    this.props.validate(error => {
      if (!error) {
        this.props.onSubmit(this.state.value)
      } else {
        if (!this._scrollingRef) return

        const errorItems =
          this._scrollingRef.getElementsByClassName('label__error')

        if (errorItems.length > 0) {
          const focusedItem = errorItems[0]
          scrollIntoView(focusedItem, {
            behavior: 'smooth',
            scrollMode: 'if-needed',
            boundary: this._scrollingRef,
          })
        }
      }
    })

  render() {
    return (
      <div className="rich-text-toolbar__settings">
        <h3 className="rich-text-toolbar__settings__header">Button settings</h3>
        <div
          className="rich-text-toolbar__settings__body"
          ref={r => {
            this._scrollingRef = r
          }}
        >
          <div ref={this._paneRef}>
            <ButtonPropsView
              value={this.state.value}
              className="rich-text-toolbar__settings__list"
              onChange={this._onChange}
              boundsRef={this._paneRef}
              onColorChange={this._onColorChange}
              onPlaylistSelect={this._onPlaylistSelect}
              validationErrors={{
                link: this.props.getValidationMessages('link').toString(),
              }}
            />
          </div>
          <ButtonContainer>
            <Button
              appearance="primary"
              caption="Apply"
              onClick={this._handleSubmit}
            />
            <Button caption="Cancel" onClick={this.props.onCancel} />
          </ButtonContainer>
        </div>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  {},
)(validation(strategy)(ButtonSettings)) as any
